import type ApplicationInstance from '@ember/application/instance';
import type PushNotifications from '../services/push-notifications';

/**
 * Push Notifications Instance Initializer
 *
 * Registers FCM listeners at app startup.
 * Does NOT request permission — that happens on user action:
 * - First login per user (tracked via localStorage)
 * - Manual submission on /extract (not share intent)
 */
export function initialize(appInstance: ApplicationInstance): void {
  void (async () => {
    try {
      const pushNotifications = appInstance.lookup(
        'service:push-notifications'
      ) as PushNotifications | undefined;
      if (pushNotifications) {
        console.log(
          '[push] App startup: registering FCM listeners via instance initializer'
        );
        await pushNotifications.registerListeners();
        pushNotifications.notifyReady();
      } else {
        console.warn(
          '[push] App startup: push-notifications service not found'
        );
      }
    } catch (err) {
      console.error('[push] App startup: instance initializer failed:', err);
    } finally {
      // Ensure the promise always resolves so the application route is never
      // left waiting indefinitely if an error occurs.
      const svc = appInstance.lookup('service:push-notifications') as
        PushNotifications | undefined;
      svc?.notifyReady();
    }
  })();
}

export default { initialize };
